import React, { useEffect } from 'react';

import './App.css';
import { Routes } from './routes';



function App() {



  return (
    <div className="App">
      <div className='App'>
        <Routes />
      </div>
    </div>
  );
}

export default App;
